import { render, staticRenderFns } from "./atualizacaoValoresFormaFarmaceutica.vue?vue&type=template&id=1b79a3ce"
import script from "./atualizacaoValoresFormaFarmaceutica.ts?vue&type=script&lang=js&external"
export * from "./atualizacaoValoresFormaFarmaceutica.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b79a3ce')) {
      api.createRecord('1b79a3ce', component.options)
    } else {
      api.reload('1b79a3ce', component.options)
    }
    module.hot.accept("./atualizacaoValoresFormaFarmaceutica.vue?vue&type=template&id=1b79a3ce", function () {
      api.rerender('1b79a3ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/atualizacaoValores/atualizacaoValoresFormaFarmaceutica.vue"
export default component.exports